import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  OWL_DATE_TIME_FORMATS,
  OWL_DATE_TIME_LOCALE,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { DATEPICKER_CONFIG, DATE_TIMEPICKER_CONFIG } from './common/constants';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';

const MODULES = [
  CommonModule,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  MatNativeDateModule,
  MatFormFieldModule,
  ReactiveFormsModule,
  MatFormFieldModule,
  MatInputModule,
  OwlMomentDateTimeModule,
];

@NgModule({
  imports: [...MODULES, FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' })],
  exports: [...MODULES, FormsModule],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, OWL_DATE_TIME_LOCALE],
    },
    { provide: OWL_DATE_TIME_FORMATS, useValue: DATE_TIMEPICKER_CONFIG },
    { provide: MAT_DATE_FORMATS, useValue: DATEPICKER_CONFIG },
  ],
})
export class DateModule {}
